export default __webpack_public_path__ + "static/media/mobile-screen.5ddfa58f.jpg";